'use strict';
/**
 * Access to the provider connect library files
 */

angular.module('msProviderConnect').service('providerLibrarySvc', ['httpSvc', function (httpSvc) {
  // Hard-coded order - we'll probably want to get that into the API some day.
  var categoryOrder = ['Training', 'Marketing Collateral', 'Tools', 'Results', 'FAQ'];

  function getFiles() {
    return httpSvc.get('/apiproxy/user/libraryfiles').then(function (categories) {
      var ret = [];
      for (var key in categories) {
        if (categories.hasOwnProperty(key)) {
          var position = categoryOrder.indexOf(key);
          // Add a Google Analytic friendly name.
          categories[key].forEach(function (file) {
            return file.analyticsFriendlyName = file.fileName.replace(/[\. ,:-]+/g, "-");
          });
          ret.push({
            categoryName: key,
            position: position,
            files: categories[key]
          });
        }
      }
      return ret;
    });
  }

  return {
    getFiles: getFiles
  };
}]);